import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CourseIntroSection from './components/CourseIntroSection';
import PricingSection from './components/PricingSection';
import TestimonialSection from './components/TestimonialSection';
import CTASection from './components/CTASection';

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <CourseIntroSection />
        <PricingSection />
        <TestimonialSection />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}